import { Warning } from '../../../assets/icons'
import { SVGWrapper } from '../../../components'
import { Section } from '../styles'

const NeedsUpdate = () => {
  return (
    <Section.ActionItemsMessage warning>
      <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
      <Section.ActionItemMessageText>
        Update investment account data; it's been over a year
      </Section.ActionItemMessageText>
    </Section.ActionItemsMessage>
  )
}

export default NeedsUpdate
